const configNode = document.getElementById('klyr-birthday-config');
if (configNode) {
  const config = JSON.parse(configNode.textContent);
  const header = document.getElementById('header-component');
  if (header) {
    const measureHeader = () => {
      document.documentElement.style.setProperty('--birthday-header-clearance', Math.ceil(header.getBoundingClientRect().height) + 'px');
      const navigation = header.querySelector('.header__columns');
      if (!navigation) return;
      const left = navigation.getBoundingClientRect().left;
      document.querySelectorAll('.klyr-birthday-photo-badge').forEach(badge => {
        const media = badge.closest('.product-information__media');
        if (media) badge.style.setProperty('--birthday-badge-left', Math.max(16, left - media.getBoundingClientRect().left) + 'px');
      });
    };
    measureHeader();
    const layoutObserver = new ResizeObserver(measureHeader);
    layoutObserver.observe(header);
    document.querySelectorAll('.product-information__media').forEach(media => layoutObserver.observe(media));
    window.addEventListener('resize', measureHeader, { passive: true });
  }
  const root = window.Shopify?.routes?.root || '/';
  const code = config.code.toUpperCase();
  const storageKey = 'klyr-birthday-code';
  const state = { wanted: false, applied: false, pending: false, busy: false, cart: null, text: config.text };
  try { state.wanted = sessionStorage.getItem(storageKey) === code; } catch (_) {}
  const saveIntent = value => {
    state.wanted = value;
    try { value ? sessionStorage.setItem(storageKey, code) : sessionStorage.removeItem(storageKey); } catch (_) {}
  };
  state.money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency, minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2
  }).format(cents / 100);
  state.hasPrice = once => (state.applied || state.pending) && (once || config.subscriptions);
  function toast(message) {
    const el = document.querySelector('[data-birthday-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(state.toastTimer);
    state.toastTimer = setTimeout(() => { el.hidden = true; }, 6000);
  }
  function render() {
    document.querySelectorAll('[data-birthday-apply]').forEach(button => {
      button.disabled = state.busy;
      button.setAttribute('aria-busy', String(state.busy));
      button.dataset.applied = String(state.applied || state.pending);
      const label = button.querySelector('[data-birthday-button-label]');
      if (label) label.textContent = state.busy ? config.text.applying : (state.applied || state.pending) ? '✓ Savings applied' : config.text.apply;
    });
    document.querySelectorAll('[data-birthday-price]').forEach(container => {
      const price = container.matches('[data-birthday-price-value]') ? container : container.querySelector('.price, [data-birthday-price-value]');
      if (!price) return;
      if (!price.dataset.originalText) price.dataset.originalText = price.textContent;
      const base = Number(container.dataset.baseCents);
      const reduced = base - Math.floor(base * .25);
      const active = state.hasPrice(true);
      const suffix = container.dataset.currencySuffix === 'false' ? '' : ' ' + container.dataset.currency;
      const nextText = active ? state.money(reduced, container.dataset.currency) + suffix : price.dataset.originalText;
      if (price.textContent !== nextText) price.textContent = nextText;
      const saving = container.querySelector('[data-birthday-saving]');
      if (saving) {
        if (!saving.dataset.originalText) saving.dataset.originalText = saving.textContent;
        const compare = Number(container.dataset.compareCents);
        const amount = Math.max(0, compare - reduced);
        const value = saving.dataset.birthdaySaving === 'percent' ? Math.round(amount / compare * 100) : state.money(amount, container.dataset.currency);
        const text = active && compare > 0 ? saving.dataset.savingTemplate.replace('__amount__', value) : saving.dataset.originalText;
        if (saving.textContent !== text) saving.textContent = text;
      }
      const label = container.querySelector('[data-birthday-price-label]');
      if (label) label.hidden = !state.hasPrice(true);
    });
  }
  function sync(cart) {
    state.cart = cart;
    const codes = cart.discount_codes || [];
    const matching = codes.find(d => d.code?.toUpperCase() === code);
    const allocation = (cart.cart_level_discount_applications || []).some(d => d.title?.toUpperCase() === code && d.total_allocated_amount > 0);
    state.applied = matching?.applicable === true || allocation;
    state.pending = state.wanted && cart.item_count === 0;
    if (state.applied) saveIntent(true);
    if (!state.applied && cart.item_count > 0 && !state.busy) { saveIntent(false); state.pending = false; }
    render();
    document.dispatchEvent(new CustomEvent('klyr:birthday', { detail: { applied: state.applied, pending: state.pending } }));
  }
  async function getCart() {
    const response = await fetch(root + 'cart.js', { cache: 'no-store' });
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  }
  async function updateCode(remove = false) {
    const cart = await getCart();
    const codes = (cart.discount_codes || []).map(d => d.code).filter(c => c.toUpperCase() !== code);
    if (!remove) codes.push(code);
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
    if (!response.ok) throw new Error('Discount request failed');
    const updated = await response.json();
    saveIntent(!remove);
    sync(updated);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: updated }));
    return updated;
  }
  state.ensureApplied = async () => {
    if (!state.wanted) return;
    try {
      const cart = await updateCode();
      if (!state.applied && cart.item_count > 0) { saveIntent(false); state.pending = false; toast(config.text.failed); }
    } catch (_) { state.applied = false; state.pending = false; toast(config.text.failed); }
    render();
  };
  document.addEventListener('click', async event => {
    const apply = event.target.closest('[data-birthday-apply]');
    const remove = event.target.closest('[data-birthday-remove]');
    if ((!apply && !remove) || state.busy) return;
    event.preventDefault();
    state.busy = true;
    render();
    const copied = apply && navigator.clipboard ? navigator.clipboard.writeText(code).then(() => true, () => false) : Promise.resolve(false);
    try {
      const cart = await updateCode(Boolean(remove));
      if (remove) {
        saveIntent(false); state.pending = false; state.applied = false;
      } else if (state.applied) {
        toast(await copied ? config.text.copied_applied : config.text.copy_failed);
      } else if (cart.item_count === 0) {
        state.pending = true;
        toast(config.text.saved);
      } else {
        saveIntent(false); state.pending = false; toast(config.text.failed);
      }
    } catch (_) { toast(config.text.failed); }
    finally { state.busy = false; render(); document.dispatchEvent(new CustomEvent('klyr:birthday')); }
  });
  document.addEventListener('cart:updated', event => {
    if (event.detail && Array.isArray(event.detail.items)) sync(event.detail);
  });
  document.addEventListener('cart:discount-update', () => getCart().then(sync).catch(() => {}));
  new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('[data-birthday-price]') || n.querySelector?.('[data-birthday-price]'))))) render();
  }).observe(document.body, { childList: true, subtree: true });
  function tick() {
    const DAY = 24 * 60 * 60; // 24 uur in seconden
    const anchor = Date.parse(config.end);
    const valid = config.countdown && Number.isFinite(anchor);
    // Telt af naar het eerstvolgende reset-moment en begint daarna weer bij 24 uur
    const diff = Math.ceil((anchor - Date.now()) / 1000);
    const remaining = ((diff % DAY) + DAY) % DAY;
    const text = [Math.floor(remaining / 3600), Math.floor(remaining / 60) % 60, remaining % 60].map(v => String(v).padStart(2, '0')).join(':');
    document.querySelectorAll('[data-birthday-countdown]').forEach(el => { el.hidden = !valid; if (valid) el.textContent = text; });
  }
  window.KlyrBirthday = state;
  tick();
  setInterval(tick, 1000);
  getCart().then(sync).catch(() => {});
}